import { ChangeEvent, Dispatch, SetStateAction } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ServiceData } from "../ScheduleSelection-Tab-Services.component";
import { ServiceDataTableRows } from "./ScheduleSelection-Tab-Services-DataTableRow.partial";

type P = {
  isEditable: boolean;
  isColleagueScheduleEditable: boolean;
  equipmentData: ServiceData[];
  setEquipmentData: Dispatch<SetStateAction<ServiceData[]>>;
};

export function ServiceEquipmentDataTable({
  isEditable,
  isColleagueScheduleEditable,
  equipmentData,
  setEquipmentData
}: Readonly<P>) {
  const { t } = useTranslation();

  /** don't used for equipment */
  /* istanbul ignore next */
  function handleChangeQty(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    item: ServiceData
  ) {
    const val = e.target.value;
    item.qty = Number(val);
    const remained = equipmentData.filter(data => data.id !== item.id);
    setEquipmentData([...remained, item]);
  }

  /* istanbul ignore next */
  function handleSelectOrder(item: ServiceData) {
    setEquipmentData(prev => [
      ...prev.filter(data => data.id !== item.id),
      item // updated one
    ]);
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell component="th">{}</TableCell>

            <TableCell>{t("Name")}</TableCell>
            <TableCell>{t("Image")}</TableCell>
            <TableCell align="left">{t("Status")}</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>

        <TableBody>
          <ServiceDataTableRows
            rowData={equipmentData}
            handleChangeQty={handleChangeQty}
            showQty={false} // ⬆ don't use quantity fn for equipment
            handleSelectOrder={handleSelectOrder}
            isEditable={isEditable}
            isColleagueScheduleEditable={isColleagueScheduleEditable}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
}
